import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import "../../assets/css/aunjai-step4.css";
import "../../assets/css/signature-mobile.css";
import { DOCUMENT_NAMES } from "../../constants/documents";
import { aunjaiScService } from "../../services/aunjai-sc.service";
import { RegisterLoan, UpdateLoan } from "../../services/modules/loan";
import { useLoanStore } from "../../stores/useLoanStore";
import { convertBase64toFile, convertFileToAttachment } from "../../utils/file";
import {
  formatAttachment,
  getAllAttachments,
  useSerializePayloadForLoanRegistration,
} from "../../utils/loan";
import Header from "../Header/stepHeader";
import { useUser } from "../../hooks/useUser";
import PrimaryButton from "../../components/ui/PrimaryButton";
import { useTranslation } from "react-i18next";
import { CONTACT } from "../../constants/contact";

const termsContent = `เงื่อนไขการให้บริการ CTS Car Protection

1. ขอบเขตการให้บริการ
${CONTACT.COMPANY_NAME_TH} ("บริษัท") ให้บริการเคลือบแก้ว ฟิล์มกันรอย ฟิล์มกรองแสง และบริการดูแลรักษารถยนต์ตามรายละเอียดที่ระบุในใบสั่งซื้อบริการ

2. การชำระเงิน
- ลูกค้าจะต้องชำระเงินมัดจำ (Deposit) ตามจำนวนที่กำหนดภายใน 3 วันหลังจากได้รับการอนุมัติ
- ค่าบริการส่วนที่เหลือจะถูกแบ่งชำระเป็นรายเดือนตามระยะเวลาสัญญาที่ตกลงไว้
- หากลูกค้าไม่ชำระเงินตามกำหนด บริษัทสงวนสิทธิ์ในการระงับบริการ

3. การรับประกัน
- บริการเคลือบแก้วคริสตัล: รับประกัน 5-7 ปี (ตลอดอายุสัญญา)
- ฟิล์มกันรอย PPF: รับประกัน 5 ปี
- ฟิล์มกรองแสง: รับประกัน 7 ปี
- การรับประกันครอบคลุมเฉพาะความเสียหายจากการใช้งานปกติ ไม่รวมอุบัติเหตุหรือการใช้งานผิดประเภท

4. การบำรุงรักษา
- ลูกค้าที่ใช้บริการแบบ Subscription จะได้รับบริการบำรุงรักษาตลอดอายุสัญญา
- การนัดหมายเข้ารับบริการบำรุงรักษาต้องแจ้งล่วงหน้าอย่างน้อย 3 วันทำการ

5. การยกเลิกบริการ
- ลูกค้าสามารถยกเลิกบริการได้โดยแจ้งล่วงหน้าอย่างน้อย 30 วัน
- กรณียกเลิกก่อนครบกำหนดสัญญา ลูกค้าจะต้องชำระค่าบริการที่คงค้างทั้งหมด
- เงินมัดจำจะไม่สามารถขอคืนได้หลังจากเริ่มให้บริการแล้ว

6. ความรับผิดชอบ
- บริษัทจะไม่รับผิดชอบต่อความเสียหายที่เกิดจากเหตุสุดวิสัย ภัยธรรมชาติ หรือการกระทำของบุคคลที่สาม
- บริษัทรับผิดชอบชดเชยความเสียหายไม่เกินมูลค่าของบริการที่ลูกค้าได้ชำระไว้

7. ข้อมูลส่วนบุคคล
- บริษัทจะเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของลูกค้าตามนโยบายความเป็นส่วนตัวของบริษัท
- ลูกค้ายินยอมให้บริษัทใช้ข้อมูลเพื่อการให้บริการและการติดต่อสื่อสาร

8. การเปลี่ยนแปลงเงื่อนไข
- บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขการให้บริการ โดยจะแจ้งให้ลูกค้าทราบล่วงหน้าไม่น้อยกว่า 15 วัน

${CONTACT.COMPANY_NAME_TH}
${CONTACT.ADDRESS_TH}
LINE: ${CONTACT.LINE_ID} | โทร: ${CONTACT.PHONE}`;

const FillFormStep4 = () => {
  const [acceptBureau, setAcceptBureau] = useState("accept");
  const { t, i18n } = useTranslation("form3");
  const [error, setError] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const sigCanvas = useRef();

  const [hasSignature, setHasSignature] = useState(false);

  const { userData } = useUser();

  const isForeigner = userData?.is_foreigner ?? false;

  const [canvasSize, setCanvasSize] = useState({
    width: window.innerWidth > 500 ? 500 : window.innerWidth - 40,
    height: 200,
  });

  const { is_mou: isMou } = useLoanStore((state) => state.incomeFormProfile);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const navigate = useNavigate();

  const formProfileData = useLoanStore((state) => state.formProfileData);

  const firstFillFormData = useLoanStore((state) => state.firstFillFormData);

  const secondFillFormData = useLoanStore((state) => state.secondFillFormData);

  const thirdFillFormData = useLoanStore((state) => state.thirdFillFormData);

  const setCreatedLoanId = useLoanStore((state) => state.setCreatedLoanId);

  const selectedLoan = useLoanStore((state) => state.selectedLoan);

  const isBeaurauConsent = acceptBureau === "accept";

  const hasUserSigned = hasSignature;
  console.log("additional_contacts:", selectedLoan);
  console.log("address:", formProfileData);
  console.log("job:", firstFillFormData);
  console.log("income:", secondFillFormData);
  console.log("general:", thirdFillFormData);
  const isSubmitButtonDisabled =
    isFormSubmitted || !isBeaurauConsent || !hasUserSigned;

  useEffect(() => {
    if (isBeaurauConsent && sigCanvas.current) {
      setHasSignature(!sigCanvas.current.isEmpty());
    }
  }, [isBeaurauConsent]);

  // Handle window resize to adjust canvas size
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth > 500 ? 500 : window.innerWidth - 40;
      setCanvasSize({
        width: newWidth,
        height: 200,
      });

      // If there's a signature, we need to redraw it on the resized canvas
      if (hasSignature && sigCanvas.current) {
        const savedData = sigCanvas.current.toData();
        setTimeout(() => {
          if (sigCanvas.current) {
            sigCanvas.current.fromData(savedData);
          }
        }, 100);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [hasSignature]);

  const goToStep5 = async () => {
    if (!isBeaurauConsent) {
      return;
    }

    // Only check for signature if the user has consented
    if (!hasUserSigned) {
      setError(true);
      return;
    }

    await handleRegisterLoan();
  };
  const serializePayloadForLoanRegistration =
    useSerializePayloadForLoanRegistration(); // ✅ This fixes the error

  const handleRegisterLoan = async () => {
    try {
      const payload = serializePayloadForLoanRegistration(
        selectedLoan,
        formProfileData,
        firstFillFormData,
        secondFillFormData,
        thirdFillFormData,
        hasUserSigned,
        isMou,
        isForeigner
      );

      const attachments = getAllAttachments({
        formProfileData,
        firstFillFormData,
        thirdFillFormData,
      });

      const signatureBase64 = sigCanvas.current.toDataURL();

      const signatureFile = convertBase64toFile(
        signatureBase64,
        `${DOCUMENT_NAMES.E_SIGN}.png`
      );

      const signatureAttachment = await convertFileToAttachment(signatureFile);

      setIsFormSubmitted(true);

      const response = await RegisterLoan({ body: payload });

      if (response.resultCode !== "20000") {
        throw response;
      }

      const loanId = response.resultData[0].loan_id;

      await UpdateLoan({
        body: {
          loan_id: loanId,
          loan_state: "request",
        },
      });

      setCreatedLoanId(loanId);

      const allAttachments = [...attachments, signatureAttachment];

      const uploadAllFilesPromise = Promise.all(
        allAttachments.map((a) =>
          aunjaiScService.insertAttachment(
            formatAttachment({
              loanId,
              attachment: a,
              fileStatus: a.name === signatureFile.name ? "approve" : undefined,
            })
          )
        )
      );

      await uploadAllFilesPromise;

      navigate("/loan-process/form-success");
    } catch (error) {
      if (error?.errors?.error) {
        alert(error.errors.error);
      } else if (error?.message) {
        alert(`Error: ${error.message}`);
      } else {
        alert("Unknown error occurred");
      }

      setIsFormSubmitted(false);
    }
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
    setHasSignature(false);
  };

  const handleSignatureStart = () => {
    document.body.classList.add("signing");
    if (sigCanvas.current) {
      setHasSignature(false);
    }
  };

  const handleSignatureEnd = () => {
    document.body.classList.remove("signing");
    if (sigCanvas.current) {
      setHasSignature(!sigCanvas.current.isEmpty());
    }
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("signing");
    };
  }, []);

  return (
    <div id="pageFillForm4">
      <Header
        title={t("header2")}
        showIcon={false}
        onBack={() => navigate("/loan-process/form-step-3")}
        step={4}
      />
      <div className="wrapContent">
        <div id="pFillForm4">
          <div className="bFillForm">
            <div className="bContent">
              <div className="bInput">
                <label>
                  {t("accept1")}{" "}
                  <span
                    onClick={() => setShowTerms(true)}
                    style={{
                      color: "var(--color-primary, #FF6500)",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    แสดงรายละเอียด
                  </span>
                </label>
                <div role="group" className="bRadioGroup">
                  {[
                    { value: "accept", label: t("accept2") },
                    { value: "decline", label: t("notAccept") },
                  ].map((option) => (
                    <label
                      key={option.value}
                      className={`bRadio ${
                        acceptBureau === option.value ? "active" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="job_type"
                        value={option.value}
                        checked={acceptBureau === option.value}
                        onChange={() => setAcceptBureau(option.value)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              {/* E-Signature section */}
              {isBeaurauConsent && (
                <div className="bEsign">
                  {error && (
                    <div className="error">
                      <p>{t("pleaseFill")}</p>
                    </div>
                  )}
                  <div className="bText">
                    <p>{t("fillName")}</p>
                  </div>
                  <div className="bSign">
                    <SignatureCanvas
                      ref={sigCanvas}
                      penColor="black"
                      canvasProps={{
                        className: "signatureCanvas",
                        width: canvasSize.width,
                        height: canvasSize.height,
                      }}
                      options={{
                        velocityFilterWeight: 0.7,
                        minWidth: 0.5,
                        maxWidth: 2.5,
                        throttle: 16,
                      }}
                      onEnd={handleSignatureEnd}
                      onBegin={handleSignatureStart}
                    />
                    <div className="bClear">
                      <button type="button" onClick={clearSignature}>
                        {t("clearSig")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <footer className="footer">
              <div className="bBtn bActionButton">
                <PrimaryButton
                  disabled={isSubmitButtonDisabled}
                  onClick={goToStep5}
                >
                  {t("confirm")}
                </PrimaryButton>
              </div>
            </footer>
          </div>
        </div>
      </div>
      {/* Terms & Conditions Modal */}
      {showTerms && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
          onClick={() => setShowTerms(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "var(--radius-card, 15px)",
              maxWidth: "560px",
              width: "100%",
              maxHeight: "80vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px",
                borderBottom: "1px solid var(--color-border, #E6E4E4)",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "var(--color-text-primary, #322E2D)",
                }}
              >
                เงื่อนไขการให้บริการ
              </h3>
              <button
                onClick={() => setShowTerms(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#999",
                  padding: "0 4px",
                }}
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div
              style={{
                padding: "24px",
                overflowY: "auto",
                fontSize: "14px",
                lineHeight: 1.8,
                color: "var(--color-text-primary, #322E2D)",
                whiteSpace: "pre-wrap",
              }}
            >
              {termsContent}
            </div>

            {/* Footer */}
            <div
              style={{
                padding: "16px 24px",
                borderTop: "1px solid var(--color-border, #E6E4E4)",
                textAlign: "center",
              }}
            >
              <button
                onClick={() => setShowTerms(false)}
                style={{
                  backgroundColor: "var(--color-primary, #FF6500)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "var(--radius-button, 10px)",
                  padding: "12px 48px",
                  fontSize: "16px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                ปิด
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FillFormStep4;
